import { Tag, Space, Avatar } from 'antd';
import { getApprovalInfoReq } from './taskStatus'
import { useEffect, useState } from 'react';
import React from 'react';
import './index.scss'

export const GrtWorkTaskStatus = (props) => {
  const { pageId, statusData: { task_id = '', proc_inst_id = '' } } = props;
  const defalutData = {
    "proc_def_name": "数据处理-test",
    "proc_def_version": 1,
    "start_user_name": "管理员",
    "head_portrait": "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif",
    "proc_status": 0
  }
  const [data, setData] = useState(defalutData);
  const getApprovalInfo = () => {
    const json = {
      task_id: task_id,
      proc_inst_id: proc_inst_id
    };

    getApprovalInfoReq(json).then((res) => {
      if (res.data) {
        setData(res.data);
      }
    });
  };

  useEffect(() => {
    if (pageId && proc_inst_id && task_id) {
      getApprovalInfo()
    }
  }, [pageId, proc_inst_id, task_id]);

  return (
    <div className='header'>
      <div className='user'>
        <Space>
          {/* <Avatar src="https://joeschmoe.io/api/v1/random" /> */}
          <Avatar src={data.head_portrait ? data.head_portrait : 'https://joeschmoe.io/api/v1/random'} />
          <span className='username'>
            {data.start_user_name}发起的{data.proc_def_name}
          </span>
        </Space>
      </div>
      <div className='status'>
        <div className='status-top'>
          <span>当前状态</span>
          <Tag>{data.proc_status === 0 ? '进行中' : '结束'}</Tag>
        </div>
        <div className='status-top'>
          <span>发起人</span>
          <span>{data.start_user_name}</span>
        </div>
        <div className='status-top'>
          <span>发起人部门</span>
          <span>{data.start_user_name}</span>
        </div>
        <div className='status-top'>
          <span>流程版本号</span>
          <span>{data.proc_def_version}</span>
        </div>
      </div>
    </div>
  );
};

